import getNegativeList from './getNegativeList'
import changeAllowNegClient from './changeAllowNegClient'
import updateNegativeRecord from './updateNegativeRecord'
import uploadNegativeList from './UploadNegativeList'
import exportNegativeList from './exportNegativeList'


export const getNegativeListPromise = getNegativeList
export const changeAllowNegClientPromise = changeAllowNegClient
export const updateNegativeRecordPropmise = updateNegativeRecord
export const uploadNegativeListPromise = uploadNegativeList
export const exportNegativeListPromise = exportNegativeList
